/* Copyright © 2026 Xerox Corporation. All Rights Reserved. Copyright protection claimed includes all forms and matters of copyrightable material and information now allowed by statutory or judicial law or hereinafter granted, including without limitation, material generated from the software programs which are displayed on the screen such as icons, screen display looks, etc. */

import { Component } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { FileService } from '../services/file.service';
import { UserService } from '../services/user.service';
import { XdaStringsService } from '../services/xda-strings.service';
import { BasicAlertComponent } from './alerts/basic-alert.component';
import { TosUpdateModalComponent } from './modals/tos-update-modal.component';

@Component({
  selector: 'xpse-entry',
  template:
    '<div class="flex-center" style="padding-top: 2rem;"><span class="xrx-activity-indicator ai-lg ai-spin"></span></div>',
  standalone: false,
})
export class XpseEntryComponent {
  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private userService: UserService,
    private fileService: FileService,
    private modalService: NgbModal,
    private xdaStringsService: XdaStringsService,
  ) {
    const fileId = this.route.snapshot.paramMap.get('file');
    const storageId = this.route.snapshot.paramMap.get('storage');
    const fileName = this.getFilenameFromRoute();

    this.fileService.currentFileId = fileId || '';
    this.fileService.currentFileName =
      fileName || 'Xerox ' + this.xdaStringsService.strings['SDE_SCAN'];

    if (storageId == '7c4cd168-34c5-4698-bfe7-6b0532025eac') {
      this.loginAsGuest();
    } else if (storageId == '0f4fc734-3813-4f8f-91d0-0c5ef44a4b3d') {
      this.requireLogin();
    }
  }

  getFilenameFromRoute(): string {
    const fileName = this.route.snapshot.queryParamMap.get('n') || '';
    const splitB64FileName = atob(fileName).split('');
    const encodedFileName = splitB64FileName
      .map((c) => {
        return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
      })
      .join('');
    return decodeURIComponent(encodedFileName);
  }

  async loginAsGuest() {
    this.userService.logOff();
    // Force eula before allowing login
    const modalRef = this.modalService.open(TosUpdateModalComponent, {
      windowClass: 'xrx-modal',
      size: 'lg',
    });
    modalRef.componentInstance.guestEula = true;
    modalRef.componentInstance.neededTos = ['eula_not_accepted'];
    modalRef.result.then(
      async () => {
        await this.userService.guestLogin();
      },
      () => {
        // Warn users if they dont accept eula they will lose their job
        this.confirmEULACancel();
      },
    );
  }

  confirmEULACancel() {
    const modalRef = this.modalService.open(BasicAlertComponent);
    modalRef.componentInstance.title = 'SDE_CONFIRM_CANCEL';
    modalRef.componentInstance.body = 'SDE_WILL_COUNT_ONE';
    modalRef.componentInstance.buttonText = 'SDE_NO';
    modalRef.componentInstance.dangerButtonText = 'SDE_YES';
    modalRef.result.then((data) => {
      if (data === 'Delete') {
        window.location.href =
          'https://www.xerox.com/en-us/office/software-solutions/xerox-workflow-central/purchase';
      } else {
        this.loginAsGuest();
      }
    });
  }

  async requireLogin() {
    // If we have a valid token, go to home screen, if the token is invalid, we are already on the home screen, so navigate to terms and then home screen
    if (await this.userService.isAuthTokenValid()) {
      this.router.navigate([''], {
        state: { displayLogin: true },
        replaceUrl: true,
      });
    } else {
      this.router.navigate(['/terms'], { skipLocationChange: true }).then(() =>
        this.router.navigate([''], {
          state: { displayLogin: true },
          replaceUrl: true,
        }),
      );
    }
  }
}
